import React from "react";
import { StatusNotificationScreen } from "../../common/StatusNotificationScreen";
import { createApi } from "../../utils/createApi";
import { markSiteUnsynced } from "../../utils/syncStore";
import { createSubmittedCameraObject } from "./createSubmittedCameraObject";
import { AxiosError, AxiosResponse } from "axios";
import { WizardCameraScreen } from "./WizardCameraScreen";
import {
  OnboardingProgressDiv,
  isCameraCheckSupported,
} from "../Onboarding/OnboardingProgressDiv";
import { ProgressFinishedScreen } from "../AddSchedule/ProgressFinishedScreen";
import { universalAPIErrorHandler } from "../../utils/universalAPIErrorHandler";
import { handleCheckCameras } from "../CameraCheck/handleCheckCameras";

export const handleSubmitCamera = async (
  values: any,
  setVisibleScreen: any,
  responseObject: any,
  setCameraCheckFinsihedAlertOpen: any,
  setGoodCameras: any,
  setConnectivityCameras: any,
  setLowResolutionCameras: any,
  setCameraCheckResultDownloadURL: any,
  navigate: any
) => {
  let onboardingFail = false;

  const navigateToAboutPage = () => {
    localStorage.removeItem("addAdditionalCamera");
    localStorage.removeItem("clickedFromSiteAboutPage");
    markSiteUnsynced();
    navigate(`/sites/aboutsite/${localStorage.siteId}`);
  };
  const retryFunction = () => {
    handleSubmitCamera(
      values,
      setVisibleScreen,
      responseObject,
      setCameraCheckFinsihedAlertOpen,
      setGoodCameras,
      setConnectivityCameras,
      setLowResolutionCameras,
      setCameraCheckResultDownloadURL,
      navigate
    );
  };
  setVisibleScreen(
    <StatusNotificationScreen
      styling="absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80"
      text={
        <p>
          Camera Add in process.
          <br />
          This might take a few seconds.
        </p>
      }
    />
  );
  const AxiosUI = createApi(`camera/onboarding/`);
  const ActuateUI = createApi(``);
  await AxiosUI.post(
    "",
    createSubmittedCameraObject(
      values,
      responseObject?.submit_object,
      responseObject?.forms
    )
  ).then(
    (response: AxiosResponse) => {
      onboardingFail = false;
      localStorage.setItem("cameraId", response.data.id);
      localStorage.removeItem("addCameraError");
      localStorage.removeItem("cameraNamingError");
      localStorage.removeItem("copyValues");
      localStorage.setItem("immixAlertsSite", "false");
      localStorage.setItem("diceAlertsSite", "false");
      localStorage.setItem("sentinelAlertsSite", "false");
      localStorage.setItem("sureviewAlertsSite", "false");
      localStorage.setItem(
        "immixAlertPostObject",
        JSON.stringify({
          id: -1,
          immix_server: "",
          immix_port: "",
        })
      );
      localStorage.setItem(
        "diceAlertPostObject",
        JSON.stringify({
          id: -1,
          dice_server: "",
          dice_port: "",
        })
      );

      setVisibleScreen(
        <StatusNotificationScreen
          styling="absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80"
          text="Camera Add successful!"
        />
      );
      setTimeout(() => {
        if (
          localStorage.addAdditionalCamera === "true" ||
          localStorage.clickedFromSiteAboutPage === "true"
        ) {
          if (isCameraCheckSupported()) {
            localStorage.setItem("cameraCheckAlertOpen", "true");
            localStorage.setItem("clickedId", localStorage.siteId);
            localStorage.setItem("navigatedFromSitesAboutPage", "true");
            localStorage.setItem("level0Click", "true");
            localStorage.setItem("cameraChecksiteId", localStorage.siteId);
            handleCheckCameras(
              setCameraCheckFinsihedAlertOpen,
              setGoodCameras,
              setConnectivityCameras,
              setLowResolutionCameras,
              localStorage.siteId,
              setCameraCheckResultDownloadURL,
              navigate
            );
          }
          navigateToAboutPage();
        } else if (localStorage.healthcheckOnly === "true") {
          // setVisibleScreen(<ProgressFinishedScreen />);
          navigate(`/sites/aboutsite/${localStorage.siteId}`);
          localStorage.setItem("healthcheckOnly", "false");
        } else if (localStorage.healthMonitoringOnly === "true") {
          localStorage.setItem("healthcheckOnly", "true");
          navigate(`/sites/cameracheck`);
        } else {
          setVisibleScreen(
            <OnboardingProgressDiv
              percentage={
                isCameraCheckSupported()
                  ? localStorage.healthMonitoringOnly === "true"
                    ? 66
                    : 50
                  : 66
              }
              step={2}
              setVisibleScreen={setVisibleScreen}
            />
          );
        }
      }, 2000);
    },
    (reason: AxiosError) => {
      onboardingFail = true;
      if (
        reason.request.response.includes(
          "Please select a different camera name"
        )
      ) {
        localStorage.setItem("cameraNamingError", "true");
        setVisibleScreen(
          <WizardCameraScreen
            setVisibleScreen={setVisibleScreen}
            responseObject={responseObject}
            setCameraCheckFinsihedAlertOpen={setCameraCheckFinsihedAlertOpen}
            setGoodCameras={setGoodCameras}
            setConnectivityCameras={setConnectivityCameras}
            setLowResolutionCameras={setLowResolutionCameras}
            setCameraCheckResultDownloadURL={setCameraCheckResultDownloadURL}
          />
        );
      } else {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          {
            alert("Error adding camera, please try again.");
            setVisibleScreen(
              <WizardCameraScreen
                setVisibleScreen={setVisibleScreen}
                responseObject={responseObject}
                setCameraCheckFinsihedAlertOpen={
                  setCameraCheckFinsihedAlertOpen
                }
                setGoodCameras={setGoodCameras}
                setConnectivityCameras={setConnectivityCameras}
                setLowResolutionCameras={setLowResolutionCameras}
                setCameraCheckResultDownloadURL={
                  setCameraCheckResultDownloadURL
                }
              />
            );
          }
        });
      }
    }
  );
  // Adding a camera no longer auto-syncs. Mark the site as having unsynced
  // changes; the operator syncs explicitly (the About-page Sync control shows
  // the unsynced state on arrival).
  if (!onboardingFail) {
    markSiteUnsynced();
  }
  !onboardingFail &&
    (await ActuateUI.get(
      `camera/site/?customer__id=${localStorage.siteId}`
    ).then(
      (response: AxiosResponse) => {
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      }
    ));
};
